import { render, staticRenderFns } from "./certificados.vue?vue&type=template&id=ea22e47a"
import script from "./certificados.vue?vue&type=script&lang=js"
export * from "./certificados.vue?vue&type=script&lang=js"
import style0 from "./certificados.vue?vue&type=style&index=0&id=ea22e47a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports